import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';
import { DoctorService } from '../../services/doctor.service';
import { Pet } from '../../classes/pet.interface';
import { MatSnackBar } from '@angular/material';
@Component({
  selector: 'app-managepet',
  templateUrl: './managepet.component.html',
  styleUrls: ['./managepet.component.css']
})
export class ManagepetComponent implements OnInit {
  petdata: Pet[];
  uid: any;
public loading= false;
   msg1: any;
   action: any;
  constructor(private commonService: CommonService, private doctorService: DoctorService,
    private snackbar: MatSnackBar) {
    const udata = this.commonService.getUserDataLocally();
    this.uid = udata.uid;
   }

  ngOnInit() {
    this.loading = true;
    this.getUserPetInfo();
  }
  getUserPetInfo() {
    this.doctorService.getUserPetInfo(this.uid)
    .subscribe(
      (pet: Pet[]) => {
        this.loading = false;
        this.petdata = pet;
  });
}
  deletepet(id) {
    this.loading = true;
    this.doctorService.deletePetDetail(id)
    .subscribe(
      () => {
        for (let i = 0; i < this.petdata.length; i++) {
          if (this.petdata[i].id === id) {
          this.petdata.splice(i, 1);
          this.loading = false;
          this.msg1 = 'Pet Information successfully Deleted';
          this.openSnackBar();
        }
      }
       });
}
openSnackBar() {
  this.snackbar.open(this.msg1 , this.action, {
    duration: 4000,
  });
 }
}
